export enum AbsenceTypeName {
  VACATION_NAME = "Urlaub",
  SICKNESS_NAME = "Krankheit",
  HOLIDAY_ADJUSTMENT_NAME = "Freizeitausgleich",
}
